import { render, staticRenderFns } from "./GItemPreviewForm.vue?vue&type=template&id=12b2ae6f&scoped=true&"
import script from "./GItemPreviewForm.vue?vue&type=script&lang=ts&"
export * from "./GItemPreviewForm.vue?vue&type=script&lang=ts&"
import style0 from "./GItemPreviewForm.vue?vue&type=style&index=0&id=12b2ae6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2ae6f",
  null
  
)

export default component.exports